// eslint-disable-next-line import/no-default-export
export { ForgotPasswordPage as default } from 'routes/forgot-password/ForgotPasswordPage'
